import { useTranslation } from "react-i18next";
import { toDateString } from "../../../../common/helper";
import { useHistory } from "react-router";

export function SimulationDocumentLine({
  simulations,
  fromUrl,
  interviewId,
  fullName,
  isRise
}) {
  const { t } = useTranslation();

  let history = useHistory();
  return (
    <>
      {" "}
      {simulations &&
        simulations.map((item, index) => (
          <tr
            onClick={() =>
              history.push(
                `/proposals/projectEstimation/${interviewId}?hash=${item.simulationHash}&fullName=${fullName}&isRise=${isRise}&returnUrl=interview/createoredit/${interviewId}?tab=documents`
              )
            }
          >
            <td>{item.simulationType}</td>
            <td>{item.ctiExtendedValue}</td>
            <td>{(item.c2K * 100).toFixed(2)}%</td>
            <td>{toDateString(item.createdOn)}</td>
            <td>{item.owner}</td>
          </tr>
        ))}
      {(!simulations || (simulations && simulations.length === 0)) && (
        <tr>
          <td colSpan="4" className="text-center">
            {t("No files added")}
          </td>
        </tr>
      )}
    </>
  );
}
